var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8198 22.6479C22.734 22.6479 22.6155 22.5899 22.4673 22.4752L16.9181 17.9107C16.8046 17.7859 16.7079 17.6179 16.6516 17.4477L16.6413 17.4189L16.6281 17.3895L16.6224 17.3798C16.5296 17.2219 16.4785 17.0521 16.4706 16.8751L17.2347 7.04442C17.3151 6.33996 17.4789 6.26943 17.8613 6.26943C18.2525 6.26943 18.4067 6.33327 18.4748 7.01139L19.2076 16.5413L23.3392 21.6175C23.5405 21.8781 23.615 22.0107 23.2417 22.384C23.0666 22.5591 22.9247 22.6479 22.8198 22.6479ZM17.869 1.98143C13.856 1.98244 10.0834 3.54581 7.24664 6.38353C4.40931 9.22166 2.84675 12.9945 2.84675 17.0071C2.84675 21.0202 4.40931 24.7929 7.24664 27.6304C10.0836 30.4685 13.856 32.0321 17.869 32.0331C21.8828 32.0331 25.6559 30.4716 28.4934 27.6357C31.3342 24.7977 32.8984 21.0231 32.8984 17.0071C32.8984 12.9916 31.3342 9.217 28.4934 6.37826C25.6561 3.54297 21.8845 1.98143 17.8729 1.98143H17.869ZM17.87 34C13.3301 33.9983 9.06193 32.2293 5.8523 29.0189C2.64246 25.808 0.875 21.5397 0.875 17C0.875 12.4603 2.64246 8.19192 5.8523 4.98088C9.06254 1.76985 13.3305 0.000982811 17.87 -3.05176e-05C22.412 -3.05176e-05 26.6812 1.76661 29.8906 4.9742C33.1049 8.18584 34.875 12.4566 34.875 17C34.875 21.5435 33.1049 25.8143 29.8906 29.0257C26.6806 32.2333 22.413 34 17.8743 34H17.87Z",
    fill: "#24272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconBlack);
export default __webpack_public_path__ + "static/media/clockIcon_black.237efa42a01902da886684f4cdfbf5e4.svg";
export { ForwardRef as ReactComponent };